import { render, staticRenderFns } from "./WorkCalendarTaskVariantGroups.vue?vue&type=template&id=236033c6&scoped=true"
import script from "./WorkCalendarTaskVariantGroups.vue?vue&type=script&lang=js"
export * from "./WorkCalendarTaskVariantGroups.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarTaskVariantGroups.vue?vue&type=style&index=0&id=236033c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236033c6",
  null
  
)

export default component.exports